export function contactCompanyFromApi(apiContact) {
  return {
    ...contactFromApi(apiContact),
    ...companyFromApi(apiContact.contact),
    type: 'company'
  };
}

export function contactPersonFromApi(apiContact) {
  return {
    ...contactFromApi(apiContact),
    ...personFromApi(apiContact.contact),
    type: 'person'
  };
}

function contactFromApi(apiContact) {
  return {
    contactCompany: apiContact.contactCompany,
    contactCompanyPath: apiContact.contactCompanyPath,
    contactName: apiContact.contactName,
    contactPath: apiContact.contactPath,
    contactType: apiContact.contactType,
    id: apiContact.id,
    relationship: apiContact.relationship,
    relationshipLabel: apiContact.relationshipLabel
  };
}

export function personFromApi(apiPerson) {
  return {
    address: apiPerson.addressFormatted,
    contactId: apiPerson.id,
    createdAt: apiPerson.createdAt,
    createdBy: apiPerson.createdBy,
    databaseName: apiPerson.databaseName,
    email: apiPerson.email,
    firstName: apiPerson.firstName,
    initials: apiPerson.initials,
    jobTitle: apiPerson.jobTitle,
    lastName: apiPerson.lastName,
    lastContacted: apiPerson.lastContacted,
    lastUpdatedAt: apiPerson.lastUpdatedAt,
    lastUpdatedBy: apiPerson.lastUpdatedBy,
    mobilePhone: apiPerson.mobilePhoneFormatted,
    mobilePhoneNormalized: apiPerson.mobilePhone,
    officePhone: apiPerson.officePhoneFormatted,
    officePhoneNormalized: apiPerson.officePhone,
    phone: apiPerson.phoneFormatted
  };
}

export function companyFromApi(apiCompany) {
  return {
    address: companyAddress(apiCompany.address),
    contactId: apiCompany.id,
    createdAt: apiCompany.createdAt,
    createdBy: apiCompany.createdBy,
    databaseName: apiCompany.databaseName,
    email: apiCompany.email,
    initials: apiCompany.initials,
    lastUpdated: apiCompany.formattedUpdatedAt,
    lastUpdatedAt: apiCompany.lastUpdatedAt,
    lastUpdatedBy: apiCompany.lastUpdatedBy,
    phone: apiCompany.phoneFormatted,
    phoneFormatted: apiCompany.officePhone
  };
}

function companyAddress(address) {
  if (!address) return;

  return address.useTruncated ? address.truncated : address.oneLine;
}
